import {
	EmbeddedCheckout,
	EmbeddedCheckoutProvider
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useMemo } from 'react';
import { createReactivationEmbeddedCheckoutSession } from '@/services/stripeService';
import { LogoText2, Rocket } from '@/resources/assets/images';

export const Reactivation = () => {
	const stripePromise = useMemo(
		() => loadStripe(String(process.env.STRIPE_PUBLIC_KEY)),
		[]
	);

	const handleFetchClientSecret = async () => {
		try {
			const { data } = await createReactivationEmbeddedCheckoutSession();
			const clientSecret = data?.data?.clientSecret;
			if (!clientSecret) {
				throw new Error('Client secret not found');
			}
			return clientSecret;
		} catch (error) {
			console.error('Error fetching client secret:', error);
			throw error;
		}
	};
	

	return (
		<div className="grid h-full w-full grid-cols-2 place-items-center">
			<div className="w-full max-w-lg">
				<header className="grid grid-rows-[auto_auto_1fr] px-4 pb-4 pt-8 lg:overflow-y-auto lg:p-10">
					<LogoText2 className="mx-auto mb-7 hidden h-12 w-[10.5rem] lg:block" />

					<div className="flex items-center justify-center gap-3 text-pretty text-center text-xl leading-snug lg:justify-between lg:text-wrap lg:text-left lg:text-[1.35rem]">
						<Rocket className="hidden lg:block" />
						Launch AI-powered Campaigns in Minutes
					</div>

					<div className="mx-4 flex flex-col text-base font-normal lg:mx-0 lg:leading-relaxed">
						<p className="mb-6 mt-4 text-center lg:text-left">
							Your leads are waiting — and our AI is ready to send
							your first campaign.
						</p>

						<p className="mb-4 font-bold">
							Add your card to unlock:
						</p>

						<ul className="mb-6 list-inside list-disc pl-2 pt-1 leading-snug">
							<li>
								Instant access: no charge today, cancel anytime
							</li>

							<li className="my-1.5">
								AI that handles outreach and follow-ups for you
							</li>

							<li>
								Verified local business contacts, ready to connect
							</li>
						</ul>

						<p className="mt-4">
							Adding your card helps us protect quality for everyone.
						</p>

						<div className="mt-11 hidden h-full min-h-28 bg-[url('../../../resources/assets/images/credit-card-image.svg')] bg-contain bg-center bg-no-repeat lg:block" />
					</div>
				</header>
			</div>
			<div className="relative flex w-full overflow-hidden rounded-[1.25rem] lg:h-full lg:w-[24.5rem]">
				<div className="no-scrollbar bottom-0 left-0 right-0 top-0 grow overflow-auto !rounded-lg lg:absolute">
					<EmbeddedCheckoutProvider
						stripe={stripePromise}
						options={{
							fetchClientSecret: handleFetchClientSecret
						}}
					>
						<EmbeddedCheckout />
					</EmbeddedCheckoutProvider>
				</div>
			</div>
		</div>
	);
}